module.exports = __webpack_public_path__ + "static/c75972b745f6864a1a3506414f25eea19653e316fc5e2dd33e63c51633f74feb-1e14db24b14983aa01bc784c84320d78.png";